import { ARENA } from '../game/constants';

interface ScrollOptions {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function drawScroll(ctx: CanvasRenderingContext2D, { x, y, width, height }: ScrollOptions): void {
  ctx.save();

  const parchmentGradient = ctx.createLinearGradient(x, y, x, y + height);
  parchmentGradient.addColorStop(0, '#f7e6c5');
  parchmentGradient.addColorStop(1, '#edd1a2');
  ctx.fillStyle = parchmentGradient;
  ctx.fillRect(x, y, width, height);

  const borderGradient = ctx.createLinearGradient(x, y, x, y + height);
  borderGradient.addColorStop(0, '#cfa76d');
  borderGradient.addColorStop(1, '#b88a4c');
  ctx.strokeStyle = borderGradient;
  ctx.lineWidth = 2;
  ctx.strokeRect(x + 1, y + 1, width - 2, height - 2);

  const rollWidth = 10;
  ctx.fillStyle = '#dcbf87';
  ctx.fillRect(x - rollWidth, y, rollWidth, height);
  ctx.fillRect(x + width, y, rollWidth, height);

  const topBandGradient = ctx.createLinearGradient(x, y, x, y + 10);
  topBandGradient.addColorStop(0, 'rgba(139, 90, 43, 0.65)');
  topBandGradient.addColorStop(1, 'rgba(139, 90, 43, 0)');
  ctx.fillStyle = topBandGradient;
  ctx.fillRect(x, y, width, 10);

  const bottomBandGradient = ctx.createLinearGradient(x, y + height - 10, x, y + height);
  bottomBandGradient.addColorStop(0, 'rgba(139, 90, 43, 0)');
  bottomBandGradient.addColorStop(1, 'rgba(139, 90, 43, 0.65)');
  ctx.fillStyle = bottomBandGradient;
  ctx.fillRect(x, y + height - 10, width, 10);

  ctx.restore();
}

export function centerScroll(width: number, height: number): { x: number; y: number } {
  return {
    x: (ARENA.width - width) / 2,
    y: (ARENA.height - height) / 2,
  };
}
